module.exports = __webpack_public_path__ + "img/DK40713816.ede9319f.png";